export function log(_ref) {
  let {
    message,
    enabled,
    objects
  } = _ref;
  if (enabled) {
    console.log("Fusion::layout ".concat(message), objects);
  }
}